<template>
    <div class="detail-condition">
        <div class="detail-condition__content" ref="detailContent">
            <div class="detail-condition__item" v-if="detail">
                <div class="detail-condition__title">{{lbl.detail.detail}}</div>
                <div class="detail-condition__text"   v-html="detail"></div>
            </div>
            <div class="detail-condition__item">
                <div class="detail-condition__title">{{lbl.detail.duration}}</div>
                <div class="detail-condition__text">{{getDateRange()}}</div>
            </div>
            <div class="detail-condition__item" v-if="condition">
                <div class="detail-condition__title">{{lbl.detail.condition}}</div>
                <div class="detail-condition__text"  v-html="condition"></div>
            </div>
        </div>
        <!-- <div class="dc-button-row"
            :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
            <div class="dc-btn"
                :class="{'active': activeTab == 'detail'}"
                @click="clickChangeTab('detail')">
                <div class="dc-inner-btn">{{lbl.detail.detail}}</div>
            </div>
            <div class="dc-btn"
                :class="{'active': activeTab == 'condition'}"
                @click="clickChangeTab('condition')">
                <div class="dc-inner-btn">{{lbl.detail.condition}}</div>
            </div>
        </div>
        <div class="dc-content"
            :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
            <div class="dc-content-item"
                v-show="activeTab === 'detail'"
                v-html="detail"></div>
            <div class="dc-content-item"
                v-show="activeTab === 'condition'"
                v-html="condition"></div>
        </div> -->
  </div>
</template>
<script>
// import Vue from 'vue';
// helper
import Util from '@/helper/Utility.js';
import Account from '@/helper/AccountHelper.js';
import DatetimeHelper from '@/helper/DatetimeHelper.js';
/**
 * @event clickChangeTab
 */
export default {
    name: "CampaignDetailAndCondtition",
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        lbl: Object,
        locale: Number,
        campaign: Object
    },
    data: function() {
        return {
            activeTab: "detail", //detail, condition
            detail: "",
            condition: "",
            profileExtensionJson: Account.getCacheProfileExtensionJson(),
            channel: ''
        };
    },
    created: function() {
        this.detail = this.initialDetail(this.campaign.detail);
        this.condition = this.initialDetail(this.campaign.condition);
    },
    mounted: function () {
        this.bindLinkInterceptor();
    },
    beforeDestroy: function () {
        this.unbindLinkInterceptor();
    },
    methods: {
        //event
        clickChangeTab: function(tab) {
            this.activeTab = tab;
        },
        //initial
        initialDetail: function (text) {
            if (!text) return '';

            var urlRegex = /(\b(https?|ftp|file):\/\/|www\.)[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|]/ig;
           
            var userDetail = Account.getCacheUserDetail();
            var tierObj = userDetail && userDetail.Meta && userDetail.Meta.Tier;
            this.channel = tierObj ? (tierObj.CHANNEL || '') : '';
            var resultPlus = '';
            // Check if text already contains an anchor tag
            if (text.indexOf('<a ') > -1) {
                resultPlus = text.replace(/href=(['"])www\./gi, 'href=$1https://www.');
            } else {
                resultPlus = text.replace(urlRegex, function (url) {
                    var href = url;
                    if (url.toLowerCase().indexOf('www.') === 0) {
                        href = 'https://' + url;
                    }

                    return '<a class="dc-link" href="' + href + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
                });
            }
            
            console.log('result', resultPlus);
            return Util.newLineToBr(resultPlus);

            // this.channel = this.Meta.Tier.CHANNEL;
            // if (this.channel == 'aiaplus') {
            //     var resultPlus = text.replace(urlRegex, function (url) {
            //         // const aiaPlusWebUrl = Vue.bzbsConfig.aiaPlusWebsiteUrl + encodeURIComponent(url)
            //         return '<a class="dc-link" href="' + url + '" target="_blank">' + url + '</a>';
            //     });
            //     return Util.newLineToBr(resultPlus);
            // } else {
            //     var result = text.replace(urlRegex, function (url) {
            //         // const aiaWebUrl = Vue.bzbsConfig.aiaWebsiteUrl + encodeURIComponent(url)
            //         return '<a class="dc-link" href="' + url + '" target="_blank">' + url + '</a>';
            //     });
            //     return Util.newLineToBr(result);
            // }
        },
        bindLinkInterceptor: function () {
            if (!this.$refs.detailContent || this._onDetailLinkClick) return;
            this._onDetailLinkClick = this.handleDetailLinkClick.bind(this);
            this.$refs.detailContent.addEventListener('click', this._onDetailLinkClick, false);
        },
        unbindLinkInterceptor: function () {
            if (!this.$refs.detailContent || !this._onDetailLinkClick) return;
            this.$refs.detailContent.removeEventListener('click', this._onDetailLinkClick, false);
            this._onDetailLinkClick = null;
        },
        normalizeExternalUrl: function (url) {
            if (!url) return '';
            if (/^www\./i.test(url)) return 'https://' + url;
            return url;
        },
        handleDetailLinkClick: function (event) {
            var anchor = event.target && event.target.closest ? event.target.closest('a') : null;
            if (!anchor) return;

            var rawHref = anchor.getAttribute('href') || '';
            var href = this.normalizeExternalUrl(rawHref);

            // keep default behavior for non-web links
            if (/^(tel:|mailto:)/i.test(href)) return;
            if (!/^(https?:\/\/)/i.test(href)) return;

            event.preventDefault();

            var os = Util.getOsName();
            if (os === 'iOS' && /^https:\/\//i.test(href)) {
                window.location.href = href.replace(/^https:\/\//i, 'x-safari-https://');
                return;
            }

            window.open(href, '_blank');
        },
        getDateRange: function () {
            var startDate = this.campaign.startDate;
            var expireDate = this.campaign.expireDate;
            
            if (!startDate || !expireDate) {
                return '';
            }

            return DatetimeHelper.dateRangeFormat(startDate, expireDate, this.lbl.date.month_short, this.locale, { useShortYear: true });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/button.scss";
 
.detail-condition {
    .detail-condition__content {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
    .detail-condition__item {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
    .detail-condition__title {
        font-size: 16px;
        font-weight: 600;
        color: $color-gray;
        // font-family: $heading;
    }
    .detail-condition__text {
        font-size: 16px;
        font-weight: 400;
        color: $color-gray;
        // font-family: $regular;
    }
}
</style>
